"use client";

import { useMemo } from "react";
import { useActivePianoNotes } from "./use-active-piano-notes";

/**
 * Pitch-class set (0..11) des notes actuellement pressées au piano,
 * octave-agnostique.
 *
 * Sémantique différente de `useChordHit` qui compare des MIDI stricts :
 * ici on raisonne en pitch-class pour les visualisations théoriques
 * (gamme, accords diatoniques) où l'inversion / l'octave n'importent pas.
 *
 * Mémoïsé sur la référence du set retourné par `useActivePianoNotes`,
 * lui-même mis à jour uniquement sur press/release.
 */
export function usePressedPitchClasses(): ReadonlySet<number> {
  const active = useActivePianoNotes();

  return useMemo(() => {
    const pcs = new Set<number>();

    for (const midi of active) {
      pcs.add(((midi % 12) + 12) % 12);
    }

    return pcs;
  }, [active]);
}
